import { constants } from '@tradetrust-tt/token-registry-v5';

const roleHash = constants.roleHash;

export { roleHash };
